// extracted by mini-css-extract-plugin
export var container = "Grid-module--container--1fvRG";
export var twoUp = "Grid-module--twoUp--ksyfZ";
export var one = "Grid-module--one--1IkrO";
export var two = "Grid-module--two--yoUhp";
export var fadeIn = "Grid-module--fadeIn--3qPmg";
export var slideIn = "Grid-module--slideIn--3IkwW";
export var bgGradient = "Grid-module--bgGradient--23-IX";
export var borderColorStep = "Grid-module--borderColorStep--2TKXX";